import { render, staticRenderFns } from "./danmu.vue?vue&type=template&id=111f0ced&scoped=true&"
import script from "./danmu.vue?vue&type=script&lang=js&"
export * from "./danmu.vue?vue&type=script&lang=js&"
import style0 from "./danmu.vue?vue&type=style&index=0&id=111f0ced&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111f0ced",
  null
  
)

export default component.exports